import styled from 'styled-components';
import { TextColor } from 'styles/Global/colorSemantic';
import { font } from 'styles/Global/globalStyles';
import { Props } from 'styles/Global/typography';

export default function DescriptionContainer({ description, padding }: { description: string; padding?: string }) {
    return (
        <Description $padding={padding}>
            <DescriptionFont>{description}</DescriptionFont>
        </Description>
    );
}

const Description = styled.div<{ $padding?: string }>`
    padding: ${(props) => props.$padding ?? '0px'};
`;

export const DescriptionFont = styled.span<Props>`
    font-size: ${font.size[16]};
    font-weight: ${font.weight.regular};
    line-height: 26px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
